import React from 'react';
import { bool, node, string } from 'prop-types';
import './SuccessTransitionText.scss';

SuccessTransitionText.propTypes = {
  text: string,
  children: node,
  showText: bool,
  isHidden: bool
};

function SuccessTransitionText(props) {
  return (
    <div className="success-transition">
      <div className={`success-transition__text ${props.showText ? 'show' : 'hide'}`}>{props.text}</div>
      <div className={`success-transition__child ${!props.isHidden && props.showText ? 'hide' : 'show'}`}>
        {props.children}
      </div>
    </div>
  );
}

SuccessTransitionText.defaultProps = {
  text: 'Success',
  showText: false,
  isHidden: false
};

export default SuccessTransitionText;
